jQuery( function ( $ ) {

    const $sections = $( 'section.form_with_entry_page' );
    if ( !$sections.length ) { return; }

    $sections.on( 'click', 'button.toggle-form', function () {
        $(this).closest( 'section.form_with_entry_page' ).addClass( 'form-activated' );
    });

});